const validateCustomParams = (customParams) => {
  const validTypes = ['string', 'boolean', 'number'];
  let isValid = true;

  if (!customParams) return { isValid: false, message: '' };

  if (Object.prototype.toString.call(customParams) !== '[object Object]'
    || Object.keys(customParams).length === 0) {
    return { isValid: false, message: 'customParams: invalid type' };
  }

  const messages = [];
  const keyRegex = /^[a-z0-9_]+$/;
  const valueRegex = /^[\wáéíúóüñç:.-]+$/;

  Object.entries(customParams).forEach(([key, value]) => {
    if (!key.match(keyRegex)) {
      messages.push(`customParams: invalid key '${key}'`);
      isValid = false;
    } else {
      const valueType = typeof value;

      if (!validTypes.includes(valueType)) {
        messages.push(`customParams: invalid prop '${key}' of type '${valueType}'`);
        isValid = false;
      } else if (valueType === 'string') {
        if (!value.match(valueRegex)) {
          messages.push(`customParams: invalid value '${value}'`);
          isValid = false;
        }
      }
    }
  });

  return { isValid, message: messages.toString() };
};

module.exports = { validateCustomParams };
